import {
  HStack,
  Icon,
  IconButton,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { CircleIcon, CircleOutlineIcon } from "../../common/icons";
import { useBreakdown } from "../../../hooks";
import { PrimaryTag } from "../../common/tags";

const BreakdownCard = (props) => {
  const {
    breakdownList,
    breakdownListLength,
    selectBreakdown,
    selectedBreakdown,
    selectedBreakdownIndex,
    selectPreviousBreakdown,
    selectNextBreakdown,
  } = useBreakdown();

  const hasMultipleWarnings = useMemo(
    () => breakdownListLength > 1,
    [breakdownListLength],
  );

  return (
    <PrimaryTag colorScheme={"gray"} {...props}>
      <VStack width={"full"} justifyContent={"center"}>
        <HStack
          width={"full"}
          justifyContent={hasMultipleWarnings ? "space-between" : "flex-start"}
        >
          {hasMultipleWarnings && (
            <IconButton
              color={"white"}
              icon={<Icon as={FaChevronLeft} boxSize={4} />}
              onClick={() => selectPreviousBreakdown()}
              variant={"link"}
            />
          )}
          <HStack>
            <Icon as={selectedBreakdown?.icon} boxSize={"24px"} color={"white"} />
            <Text
              color={"white"}
              fontWeight={400}
              fontSize={"16px"}
              wordBreak={"break-word"}
            >
              {selectedBreakdown?.status}
            </Text>
          </HStack>
          {hasMultipleWarnings && (
            <IconButton
              color={"white"}
              icon={<Icon as={FaChevronRight} boxSize={4} />}
              onClick={() => selectNextBreakdown()}
              variant={"link"}
            />
          )}
        </HStack>
        {hasMultipleWarnings && (
          <HStack justifyContent={"center"} width={"full"}>
            {breakdownList.map((breakdown, index) => (
              <IconButton
                color={"white"}
                icon={
                  index === selectedBreakdownIndex ? (
                    <CircleIcon boxSize={2} />
                  ) : (
                    <CircleOutlineIcon boxSize={2} />
                  )
                }
                key={breakdown.status}
                minWidth={0}
                onClick={() => selectBreakdown(index)}
                variant={"link"}
              />
            ))}
          </HStack>
        )}
      </VStack>
    </PrimaryTag>
  );
};

export default React.memo(BreakdownCard);
